export default {

    getLanguageIsoList() {
        return [
            {name: "isiZulu", iso: "zu"},
            {name: "Chinesisch", iso: "zh"},
            {name: "Zhuang", iso: "za"},
            {name: "Yoruba", iso: "yo"},
            {name: "Jiddisch", iso: "yi"},
            {name: "isiXhosa", iso: "xh"},
            {name: "Wolof", iso: "wo"},
            {name: "Wallonisch", iso: "wa"},
            {name: "Volapük", iso: "vo"},
            {name: "Vietnamesisch", iso: "vi"},
            {name: "Tshivenda", iso: "ve"},
            {name: "Usbekisch", iso: "uz"},
            {name: "Urdu", iso: "ur"},
            {name: "Ukrainisch", iso: "uk"},
            {name: "Uigurisch", iso: "ug"},
            {name: "Tahitisch", iso: "ty"},
            {name: "Twi", iso: "tw"},
            {name: "Tatarisch", iso: "tt"},
            {name: "Xitsonga", iso: "ts"},
            {name: "Türkisch", iso: "tr"},
            {name: "Tongaisch", iso: "to"},
            {name: "Setswana", iso: "tn"},
            {name: "Tagalog", iso: "tl"},
            {name: "Turkmenisch", iso: "tk"},
            {name: "Tigrinya", iso: "ti"},
            {name: "Thai", iso: "th"},
            {name: "Tadschikisch", iso: "tg"},
            {name: "Telugu", iso: "te"},
            {name: "Tamil", iso: "ta"},
            {name: "Swahili", iso: "sw"},
            {name: "Schwedisch", iso: "sv"},
            {name: "Sundanesisch", iso: "su"},
            {name: "Süd-Sotho", iso: "st"},
            {name: "Siswati", iso: "ss"},
            {name: "Serbisch", iso: "sr"},
            {name: "Albanisch", iso: "sq"},
            {name: "Somali", iso: "so"},
            {name: "Shona", iso: "sn"},
            {name: "Samoanisch", iso: "sm"},
            {name: "Slowenisch", iso: "sl"},
            {name: "Slowakisch", iso: "sk"},
            {name: "Singhalesisch", iso: "si"},
            {name: "Sango", iso: "sg"},
            {name: "Nordsamisch", iso: "se"},
            {name: "Sindhi", iso: "sd"},
            {name: "Sardisch", iso: "sc"},
            {name: "Sanskrit", iso: "sa"},
            {name: "Ruandisch", iso: "rw"},
            {name: "Russisch", iso: "ru"},
            {name: "Rumänisch", iso: "ro"},
            {name: "Kirundi", iso: "rn"},
            {name: "Romanisch", iso: "rm"},
            {name: "Quechua", iso: "qu"},
            {name: "Portugiesisch", iso: "pt"},
            {name: "Paschtunisch", iso: "ps"},
            {name: "Polnisch", iso: "pl"},
            {name: "Pali", iso: "pi"},
            {name: "Pandschabi", iso: "pa"},
            {name: "Ossetisch", iso: "os"},
            {name: "Oriya", iso: "or"},
            {name: "Oromo", iso: "om"},
            {name: "Ojibwe", iso: "oj"},
            {name: "Okzitanisch", iso: "oc"},
            {name: "Chichewa", iso: "ny"},
            {name: "Navajo", iso: "nv"},
            {name: "Süd-Ndebele", iso: "nr"},
            {name: "Norwegisch", iso: "no"},
            {name: "Nynorsk", iso: "nn"},
            {name: "Niederländisch", iso: "nl"},
            {name: "Ndonga", iso: "ng"},
            {name: "Nepali", iso: "ne"},
            {name: "Nord-Ndebele", iso: "nd"},
            {name: "Bokmål", iso: "nb"},
            {name: "Nauruisch", iso: "na"},
            {name: "Birmanisch", iso: "my"},
            {name: "Maltesisch", iso: "mt"},
            {name: "Malaiisch", iso: "ms"},
            {name: "Marathi", iso: "mr"},
            {name: "Mongolisch", iso: "mn"},
            {name: "Malayalam", iso: "ml"},
            {name: "Mazedonisch", iso: "mk"},
            {name: "Maori", iso: "mi"},
            {name: "Marshallesisch", iso: "mh"},
            {name: "Malagassi", iso: "mg"},
            {name: "Lettisch", iso: "lv"},
            {name: "Kiluba", iso: "lu"},
            {name: "Litauisch", iso: "lt"},
            {name: "Laotisch", iso: "lo"},
            {name: "Lingála", iso: "ln"},
            {name: "Limburgisch", iso: "li"},
            {name: "Luganda", iso: "lg"},
            {name: "Luxemburgisch", iso: "lb"},
            {name: "Latein", iso: "la"},
            {name: "Kirgisisch", iso: "ky"},
            {name: "Kornisch", iso: "kw"},
            {name: "Komi", iso: "kv"},
            {name: "Kurdisch", iso: "ku"},
            {name: "Kashmiri", iso: "ks"},
            {name: "Kanuri", iso: "kr"},
            {name: "Koreanisch", iso: "ko"},
            {name: "Kannada", iso: "kn"},
            {name: "Khmer", iso: "km"},
            {name: "Grönländisch", iso: "kl"},
            {name: "Kasachisch", iso: "kk"},
            {name: "oshiKwanyama", iso: "kj"},
            {name: "Kikuyu", iso: "ki"},
            {name: "Kikongo", iso: "kg"},
            {name: "Georgisch", iso: "ka"},
            {name: "Javanisch", iso: "jv"},
            {name: "Japanisch", iso: "ja"},
            {name: "Inuktitut", iso: "iu"},
            {name: "Italienisch", iso: "it"},
            {name: "Isländisch", iso: "is"},
            {name: "Ido", iso: "io"},
            {name: "Inupiaq", iso: "ik"},
            {name: "Yi", iso: "ii"},
            {name: "Igbo", iso: "ig"},
            {name: "Interlingue", iso: "ie"},
            {name: "Indonesisch", iso: "id"},
            {name: "Interlingua", iso: "ia"},
            {name: "Otjiherero", iso: "hz"},
            {name: "Armenisch", iso: "hy"},
            {name: "Ungarisch", iso: "hu"},
            {name: "Haitianisch", iso: "ht"},
            {name: "Kroatisch", iso: "hr"},
            {name: "Hiri Motu", iso: "ho"},
            {name: "Hindi", iso: "hi"},
            {name: "Hebräisch", iso: "he"},
            {name: "Hausa", iso: "ha"},
            {name: "Manx-Gälisch", iso: "gv"},
            {name: "Gujarati", iso: "gu"},
            {name: "Guaraní", iso: "gn"},
            {name: "Galegisch", iso: "gl"},
            {name: "Schottisch-gälisch", iso: "gd"},
            {name: "Irisch", iso: "ga"},
            {name: "Westfriesisch", iso: "fy"},
            {name: "Französisch", iso: "fr"},
            {name: "Färöisch", iso: "fo"},
            {name: "Fidschi", iso: "fj"},
            {name: "Finnisch", iso: "fi"},
            {name: "Fulfulde", iso: "ff"},
            {name: "Persisch", iso: "fa"},
            {name: "Baskisch", iso: "eu"},
            {name: "Estnisch", iso: "et"},
            {name: "Spanisch", iso: "es"},
            {name: "Esperanto", iso: "eo"},
            {name: "Englisch", iso: "en"},
            {name: "Griechisch", iso: "el"},
            {name: "Ewe", iso: "ee"},
            {name: "Dzongkha", iso: "dz"},
            {name: "Dhivehi", iso: "dv"},
            {name: "Deutsch", iso: "de"},
            {name: "Dänisch", iso: "da"},
            {name: "Walisisch", iso: "cy"},
            {name: "Tschuwaschisch", iso: "cv"},
            {name: "Kirchenslawisch", iso: "cu"},
            {name: "Tschechisch", iso: "cs"},
            {name: "Cree", iso: "cr"},
            {name: "Korsisch", iso: "co"},
            {name: "Chamorro", iso: "ch"},
            {name: "Tschetschenisch", iso: "ce"},
            {name: "Katalanisch", iso: "ca"},
            {name: "Bosnisch", iso: "bs"},
            {name: "Bretonisch", iso: "br"},
            {name: "Tibetisch", iso: "bo"},
            {name: "Bengalisch", iso: "bn"},
            {name: "Bambara", iso: "bm"},
            {name: "Bislama", iso: "bi"},
            {name: "Bihari", iso: "bh"},
            {name: "Bulgarisch", iso: "bg"},
            {name: "Weißrussisch", iso: "be"},
            {name: "Baschkirisch", iso: "ba"},
            {name: "Aserbaidschanisch", iso: "az"},
            {name: "Aymara", iso: "ay"},
            {name: "Avarisch", iso: "av"},
            {name: "Assamesisch", iso: "as"},
            {name: "Arabisch", iso: "ar"},
            {name: "Aragonesisch", iso: "an"},
            {name: "Amharisch", iso: "am"},
            {name: "Akan", iso: "ak"},
            {name: "Afrikaans", iso: "af"},
            {name: "Avestisch", iso: "ae"},
            {name: "Abchasisch", iso: "ab"},
            {name: "Afar", iso: "aa"},
            {name: "Serbokroatisch", iso: "sh"},

            //"schweizerdeutsch" as custom language (actually its a dialect and should not be here ...)
            {name: "Schweizerdeutsch", iso: "schd"},
        ];
    }
}